import * as React from "react";

const ScopePage : React.FC = () => {
    return (
        <div>
            <div>
                <img src={"/images/header_scope.png"} className={"header"}/>
            </div>
            <div className={"scope"}>
                <img src={"/images/scope1.gif"}/>
            </div>
            <div className={"scope"}>
                <img src={"/images/scope2.gif"}/>
            </div>
            <div>
                <a href={"/setubi.html#scope"}>戻る</a>
            </div>
        </div>
    );
}

export default ScopePage;
